var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-col",
    { staticClass: "flex" },
    [
      _c("SearchTerm", {
        attrs: { contracts: _vm.mainContracts },
        on: { clearRes: _vm.clearSearch, searchRes: _vm.setSearch },
      }),
      _vm.view
        ? _c(
            "div",
            [
              _c("WSTable", {
                ref: "wstable",
                attrs: { position: _vm.position, view: _vm.view },
                on: { hideTable: _vm.hideView },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "ib-table-basic",
        {
          staticClass: "quotes",
          attrs: {
            data: _vm.search.length > 0 ? _vm.search : _vm.mainContracts,
            root: "window",
            "root-margin": "156px",
            rowstripe: "",
            rowborder: "",
            colborder: "",
          },
          on: { enter: _vm.rowEnter },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function (pos) {
                return [
                  _c("td", { attrs: { title: pos.ticker } }, [
                    _c("span", {
                      staticClass: "end-8 text-bold",
                      domProps: { textContent: _vm._s(pos.ticker) },
                    }),
                  ]),
                  _c(
                    "td",
                    {
                      attrs: { title: pos.desc },
                      on: {
                        click: function ($event) {
                          return _vm.viewTable(pos)
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "red",
                        domProps: { textContent: _vm._s(pos.desc) },
                      }),
                    ]
                  ),
                  _c("td", { attrs: { title: pos.currency } }, [
                    _c("span", {
                      staticClass: "end-8 text-bold",
                      domProps: { textContent: _vm._s(pos.currency) },
                    }),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _c("ib-table-col", { attrs: { width: "12ch", sticky: "" } }, [
            _vm._v(_vm._s(_vm.$t("ib_symbol")) + "    "),
          ]),
          _c("ib-table-col", { attrs: { width: "36ch" } }, [
            _vm._v(
              _vm._s(_vm.$t("product_description")) +
                " (" +
                _vm._s(_vm.$t("more_details")) +
                ")"
            ),
          ]),
          _c("ib-table-col", { attrs: { width: "12ch" } }, [
            _vm._v(_vm._s(_vm.$t("currency")) + "    "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }